export var getNodesSet = function (category) {
    var set = new Set();
    var nodes = [category];
    if (!(category === null || category === void 0 ? void 0 : category.id)) {
        return set;
    }
    while (nodes.length > 0) {
        var node = nodes.shift();
        if (node) {
            set.add(node === null || node === void 0 ? void 0 : node.id);
            nodes.unshift.apply(nodes, ((node === null || node === void 0 ? void 0 : node.categories) || []));
        }
    }
    return set;
};
export var find = function (category, id) {
    if (!id || !category) {
        return null;
    }
    var nodes = [category];
    while (nodes.length > 0) {
        var node = nodes.shift();
        if ((node === null || node === void 0 ? void 0 : node.id) === id) {
            return node;
        }
        nodes.unshift.apply(nodes, ((node === null || node === void 0 ? void 0 : node.categories) || []));
    }
    return null;
};
export var findPath = function (parentCategory, category) {
    if (!category || !parentCategory) {
        return [];
    }
    if (category.id === parentCategory.id) {
        return [category.id];
    }
    var parentOf = {};
    var nodes = [parentCategory];
    var _loop_1 = function () {
        var node_1 = nodes.shift();
        if (node_1 && node_1.categories) {
            node_1.categories.forEach(function (c) {
                parentOf[c.id] = node_1;
            });
            nodes.unshift.apply(nodes, node_1.categories);
        }
    };
    while (nodes.length > 0) {
        _loop_1();
    }
    var path = [];
    var node = category;
    while (node && node.id !== parentCategory.id) {
        path.push(node.id);
        node = parentOf[node.id];
    }
    if (node && node.id === parentCategory.id) {
        path.push(node.id);
        return path;
    }
    return [];
};
export var findOnlyChildSuccessor = function (category, depth, maxDepth) {
    var _a;
    var node = category;
    var currentDepth = depth;
    while (!!(node === null || node === void 0 ? void 0 : node.id) && ((_a = node === null || node === void 0 ? void 0 : node.categories) === null || _a === void 0 ? void 0 : _a.length) === 1 && currentDepth < maxDepth) {
        node = node.categories[0];
        currentDepth += 1;
    }
    return node;
};
